import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';
import { store } from '~/store/configureStore';

/**
 * Forces a token refresh before the credentials write, as `watchEditUserOfficeInfo` does
 * (profileSaga.js). Same refresh-and-store pair `getAuthHeaders` runs for an expired token.
 */
export const refreshAuthToken = async (): Promise<void> => {
  const response = await apiMethods.authRefreshRequest(
    localStorage.getItem('refresh_token_dental'),
  );
  store.dispatch({ type: apiMethodsConst.AUTH_REFRESH_REQUEST, payload: response });
};
